import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CampaignState {
  list: any[];
  isLoading: boolean;
  statusFilter: number; // 0 = All, 1 = Active, 2 = Paused
  searchQuery: string;
}

const initialState: CampaignState = {
  list: [],
  isLoading: false,
  statusFilter: 0,
  searchQuery: '',
};

const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    fetchCampaignsStart(state) {
      state.isLoading = true;
    },
    fetchCampaignsSuccess(state, action: PayloadAction<any[]>) {
      state.list = action.payload;
      state.isLoading = false;
    },
    fetchCampaignsFailure(state) {
      state.isLoading = false;
    },
    setStatusFilter(state, action: PayloadAction<number>) {
      state.statusFilter = action.payload;
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    updateCampaignStatusOptimistic(state, action: PayloadAction<{ id: string; status: number }>) {
      const campaign = state.list.find(c => c.id === action.payload.id || c._id === action.payload.id);
      if (campaign) campaign.status = action.payload.status;
    }
  },
});

export const {
  fetchCampaignsStart,
  fetchCampaignsSuccess,
  fetchCampaignsFailure,
  setStatusFilter,
  setSearchQuery,
  updateCampaignStatusOptimistic
} = campaignsSlice.actions;

export default campaignsSlice.reducer;